module.exports = __webpack_public_path__ + "img/about_02_m.5f990fe7.png";